const { prvaDiagnozaGDPRSoglasje } = require("./GDPRSoglasje.model");
const { prvaDiagnozaIdd2 } = require("./idd2.model");
const { prvaDiagnozaIzbiraPaketa } = require("./izbira.paketa.model");
const { prvaDiagnozaIzjava } = require("./izjava.model");
const { prvaDiagnozaPremija } = require("./premija.model");
const { prvaDiagnozaSepa } = require("./sepa.model");
const { prvaDiagnozaZavarovalec } = require("./zavarovalec.model");
const { prvaDiagnozaZavarovanec } = require("./zavarovanec.model");

const prvadiagnoza202204Model = {
    idd2: prvaDiagnozaIdd2,
    zavarovalec: prvaDiagnozaZavarovalec,
    zavarovanaOseba: prvaDiagnozaZavarovanec,
    izbiraPaketa: prvaDiagnozaIzbiraPaketa,
    premija: prvaDiagnozaPremija,
    sepa: prvaDiagnozaSepa,
    izjava: prvaDiagnozaIzjava,
    GDPRSoglasje: prvaDiagnozaGDPRSoglasje,
};

module.exports = { 
    prvadiagnoza202204Model,
    getPrvadiagnoza202204Model: () => {
        // TODO - without json parse
        return JSON.parse(JSON.stringify(prvadiagnoza202204Model))
    }
};

